export class MediaContentViewModel {
    public mediaContentId: string;
    public organisationId: string;
    public languageCode: string;
    public languageName: string;
    public primaryLanguageFlag: boolean;
    public mediaText: string;
    public originalFileName: string;
    public logicalLocation: string;
    public physicalLocation: string;
    public thumbnailLogicalLocation: string;
    public thumbnailPhysicalLocation: string;
    public mediaFileBase64: string;
}